import { useTranslate } from "helpers";
import { memo } from "react";
import { ContactAddressSearchTabProps } from "./types";
import { NoResults } from "ui/components/NoResults";
import ContactAddressSearchResults from "../ContactAddressSearchResults/ContactAddressSearchResults";


const ContactAddressSearchTab: React.FC<ContactAddressSearchTabProps> = (props) => {
  const {
    searchResults,
    isLoading,
    onRowClick,
    onGoogleMapClick,
    onWhatsAppClick,
    onViberClick,
    onCopyLinkClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <div className="mx-[-1px]">
      {!isLoading && searchResults.pagination.totalPages === 0 ? (
        <NoResults message={t("admin.contact.address.search.noresults")} />
      ) : (
        <ContactAddressSearchResults
          searchResults={searchResults}
          selectedRows={[]}
          isLoading={isLoading}
          onRowClick={onRowClick}
          onGoogleMapClick={onGoogleMapClick}
          onWhatsAppClick={onWhatsAppClick}
          onViberClick={onViberClick}
          onCopyLinkClick={onCopyLinkClick}
          onDeleteClick={onDeleteClick}
        />
      )}
    </div>
  );
};

export default memo(ContactAddressSearchTab);
